import type { PipelineStage } from './workspaces';
import type { StatusBadgeVariant } from '../components/ui/StatusBadge';

/** What each pipeline stage is called on screen. */
export const PIPELINE_STAGE_LABELS: Readonly<Record<PipelineStage, string>> = {
  lead: 'Lead', proposal: 'Proposal', booked: 'Booked', delivering: 'Delivering', won: 'Won', lost: 'Lost',
};

/** Badge colour of a stage; the label is always shown too, so colour is never the only signal. */
export const PIPELINE_STAGE_VARIANT: Readonly<Record<PipelineStage, StatusBadgeVariant>> = {
  lead: 'neutral', proposal: 'info', booked: 'primary', delivering: 'warning', won: 'success', lost: 'danger',
};
